import type { ReactElement } from "react"

import { SecurityObjectExt } from "~/domain/user-session"

export function getErrorMessageFromObjects(
	objects: string | SecurityObjectExt | SecurityObjectExt[] | undefined,
	objectIndex: number | undefined,
	defErrorMessage: string | ReactElement | undefined
) {
	let errorMessage: string | ReactElement = defErrorMessage ?? ""

	if (typeof objectIndex === "number" && typeof objects === "object") {
		if (objects instanceof Array) {
			errorMessage = objects[objectIndex]?.errorMessage ?? ""
		} else if (objectIndex === 0) {
			errorMessage = objects?.errorMessage ?? ""
		} else {
			throw new Error("Некорректный индекс `objectIndex`")
		}
	}
	return errorMessage
}